import { RewardsHubDto, RewardsHubKeys } from '@/api/Trading-Accounts/Types/RewardsHubDto'
import { formatLocalDateUTC } from '@/utils/date'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const rewardsHubColumns: GridColumn[] = [
  {
    title: 'Reward name (internal)',
    field: RewardsHubKeys.internalName,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Display name (client facing)',
    field: RewardsHubKeys.displayName,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Category',
    field: RewardsHubKeys.category,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Property Value',
    field: RewardsHubKeys.propertyValue,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'numeric',
  },
  {
    title: 'Key Parameters',
    field: RewardsHubKeys.propertyValue,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    cell: (props) => {
      const item: RewardsHubDto = props.dataItem
      const spins = item.spinRewardConfiguration?.amountOfSpins
      const tradingView = item.tradingViewRewardConfiguration?.tradingViewPlan.name
      const expiry = item.defaultExpirationInDays

      return (
        <td className='table-columns__content'>
          {spins !== undefined && (
            <span>
              Spins: {spins}
              <br />
            </span>
          )}
          {tradingView && (
            <span>
              Plan: {tradingView}
              <br />
            </span>
          )}
          {expiry && <span>Expiry: {expiry} days</span>}
        </td>
      )
    },
  },
  {
    title: 'Status',
    field: RewardsHubKeys.status,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Usage',
    field: RewardsHubKeys.usage,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Last Modified',
    field: RewardsHubKeys.lastModified,
    className: 'table-columns__content',
    show: true,
    filterable: true,
    filter: 'date',
    cell: (props: GridCellProps) => (
      <td>{formatLocalDateUTC(props.dataItem.lastModified, true)}</td>
    ),
  },
]
